<template>
  <div class="stepper-list">
    <div
      v-for="(step, i) in visibleSteps"
      :key="i"
      class="stepper-list__item d-flex align-start"
      :class="i < visibleSteps.length - 1 ? 'mb-4' : ''"
    >
      <!-- Step indicator -->
      <div
        class="stepper-list__bullet flex-shrink-0 mr-3 d-flex align-center justify-center"
        :class="
          isDone(i)
            ? 'stepper-list__bullet--done'
            : 'stepper-list__bullet--active'
        "
      >
        <v-icon v-if="isDone(i)" small color="white">mdi-check</v-icon>
        <span v-else class="caption font-weight-bold white--text">{{
          i + 1
        }}</span>
      </div>

      <!-- Step content -->
      <div class="pt-1">
        <div
          class="text-body-2 font-weight-medium"
          :class="!isDone(i) ? 'primary--text' : 'text--secondary'"
        >
          {{ step.title }}
        </div>
        <div class="text-caption text--secondary">{{ step.desc }}</div>
      </div>
    </div>

    <!-- Next button -->
    <div
      v-if="showNextButton && currentStep < steps.length - 1"
      class="mt-5 d-flex justify-end"
    >
      <v-btn color="primary" depressed @click="$emit('next')">
        Weiter
        <v-icon right small>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepperList",
  props: {
    /**
     * Array of step objects: { title: String, desc: String }
     */
    steps: {
      type: Array,
      required: true,
    },
    /**
     * 0-based index of the currently active step.
     */
    currentStep: {
      type: Number,
      default: 0,
    },
    /**
     * Whether to render the "Weiter >" button.
     * Useful to disable when steps advance automatically.
     */
    showNextButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["next"],
  computed: {
    /**
     * Only the steps up to (and including) the currently active one are visible.
     */
    visibleSteps() {
      return this.steps.slice(0, this.currentStep + 1);
    },
  },
  methods: {
    isDone(visibleIndex) {
      return visibleIndex < this.currentStep;
    },
  },
};
</script>

<style scoped>
.stepper-list__bullet {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex-shrink: 0;
}

.stepper-list__bullet--active {
  background: #1976d2;
}

.stepper-list__bullet--done {
  background: #43a047;
}
</style>
